import React from 'react';
import './Header.css';

import MenuBar from './MenuBar.js'

const Header = ({menuLogo, menuOptions}) => {
  return (
    <MenuBar
      logo={menuLogo}
      options={menuOptions}></MenuBar>
      
  );
}

export default Header;